var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup40X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5424 11.2479C7.2244 11.2479 5.34424 9.36682 5.34424 7.04767C5.34424 4.72852 7.2244 2.84741 9.5424 2.84741C11.8604 2.84741 13.7406 4.72852 13.7406 7.04767C13.7406 9.36682 11.8604 11.2479 9.5424 11.2479ZM9.5424 3.49162C7.58497 3.49162 5.98813 5.08927 5.98813 7.04767C5.98813 9.00606 7.58497 10.6037 9.5424 10.6037C11.4998 10.6037 13.0967 9.00606 13.0967 7.04767C13.0967 5.08927 11.4998 3.49162 9.5424 3.49162Z",
    fill: "#233A80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7284 18.2694C15.1315 18.2694 13.8438 16.9681 13.8438 15.3834C13.8438 13.7986 15.1444 12.4973 16.7284 12.4973C18.3123 12.4973 19.613 13.7986 19.613 15.3834C19.613 16.9681 18.3123 18.2694 16.7284 18.2694ZM16.7284 13.1286C15.4921 13.1286 14.4876 14.1336 14.4876 15.3705C14.4876 16.6074 15.4921 17.6123 16.7284 17.6123C17.9646 17.6123 18.9691 16.6074 18.9691 15.3705C18.9691 14.1336 17.9646 13.1286 16.7284 13.1286Z",
    fill: "#233A80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9099 11.6214C21.6092 11.6214 20.5532 10.5649 20.5532 9.26355C20.5532 7.96225 21.6092 6.90576 22.9099 6.90576C24.2105 6.90576 25.2665 7.96225 25.2665 9.26355C25.2665 10.5649 24.2105 11.6214 22.9099 11.6214ZM22.9099 7.56285C21.9698 7.56285 21.1971 8.32302 21.1971 9.27645C21.1971 10.2299 21.9569 10.99 22.9099 10.99C23.8628 10.99 24.6226 10.217 24.6226 9.27645C24.6226 8.3359 23.8628 7.56285 22.9099 7.56285Z",
    fill: "#233A80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08664 19.3002C4.01778 19.3002 3.14209 18.4241 3.14209 17.3547C3.14209 16.2853 4.01778 15.4092 5.08664 15.4092C6.15549 15.4092 7.03118 16.2853 7.03118 17.3547C7.03118 18.4241 6.15549 19.3002 5.08664 19.3002ZM5.08664 16.0534C4.36548 16.0534 3.78598 16.6332 3.78598 17.3547C3.78598 18.0762 4.36548 18.656 5.08664 18.656C5.80779 18.656 6.3873 18.0762 6.3873 17.3547C6.3873 16.6332 5.80779 16.0534 5.08664 16.0534Z",
    fill: "#233A80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2925 21.8902H0V0H0.643889V21.246H28.2925V21.8902Z",
    fill: "#233A80"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15.5L3.5 16.5V17L4 18.5L5.5 19L6.5 18V17L6 16L4.5 15.5Z",
    fill: "#233A80"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.5L6 5.5L5.5 7L6.5 9.5L9 11L11.5 10.5L13.5 8L13 5.5L11.5 3.5L10 3L7.5 3.5Z",
    fill: "#233A80"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13L14.5 14L14 15.5L14.5 16.5L16 18H17.5L19 16.5L19.5 15L18 13H16Z",
    fill: "#233A80"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7L21.5 8L21 9L21.5 11L23 11.5L24.5 10.5L25 9L24 7.5L22.5 7Z",
    fill: "#233A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup40X);
export default __webpack_public_path__ + "static/media/Group40x.2bfb8d1578b7c8845cfe6b26d653e4e9.svg";
export { ForwardRef as ReactComponent };